// 工作台
export default [
  {
    path: "/Work",
    name: "Work",
    component: () => import("@/CommonDP/pages/mainMg/workbench/workbench"),
    meta: {
      routeName: "工作台",
      icon: require("@/CommonDP/assets/settings/Work.svg")
    },
    children: [
      {
        path: "/workProjectBoard",
        name: "workProjectBoard",
        component: () =>
          import(
            "@/CommonDP/pages/mainMg/workbench/workProjectBoard/workProjectBoard.vue"
          ),
        meta: {
          routeName: "项目看板",
          prouteName: "项目看板",
          pname: "工作台",
          icon1: require("@/CommonDP/assets/settings/workProjectBoard.svg"),
          icon2: require("@/CommonDP/assets/settings/workProjectBoard.svg")
        },
        children: []
      },
      {
        path: "/recentdoc",
        name: "recentdoc",
        component: () =>
          import("@/CommonDP/pages/mainMg/workbench/recentdoc/recentdoc"),
        meta: {
          routeName: "最近文档",
          prouteName: "最近文档",
          pname: "工作台",
          icon1: require("@/CommonDP/assets/settings/recentdoc.svg"),
          icon2: require("@/CommonDP/assets/settings/recentdoc.svg")
        },
        children: []
      },
      {
        path: "/myAgency",
        name: "myAgency",
        component: () =>
          import("@/CommonDP/pages/mainMg/workbench/workProcess/myAgency.vue"),
        meta: {
          routeName: "我的待办",
          prouteName: "我的待办",
          pname: "工作台",
          icon1: require("@/CommonDP/assets/settings/myAgency.svg"),
          icon2: require("@/CommonDP/assets/settings/myAgency.svg")
        }
      },
      {
        path: "/myEstablish",
        name: "myEstablish",
        component: () =>
          import("@/CommonDP/pages/mainMg/workbench/workProcess/myEstablish.vue"),
        meta: {
          routeName: "我的创建",
          prouteName: "我的创建",
          pname: "工作台",
          icon1: require("@/CommonDP/assets/settings/myEstablish.svg"),
          icon2: require("@/CommonDP/assets/settings/myEstablish.svg")
        }
      },
      {
        path: "/myFinished",
        name: "myFinished",
        component: () =>
          import("@/CommonDP/pages/mainMg/workbench/workProcess/myFinished.vue"),
        meta: {
          routeName: "我的已办",
          prouteName: "我的已办",
          pname: "工作台",
          icon1: require("@/CommonDP/assets/settings/myFinished.svg"),
          icon2: require("@/CommonDP/assets/settings/myFinished.svg")
        }
      },
      {
        path: "/myCopysend",
        name: "myCopysend",
        component: () =>
          import("@/CommonDP/pages/mainMg/workbench/workProcess/myCopysend.vue"),
        meta: {
          routeName: "我的抄送",
          prouteName: "我的抄送",
          pname: "工作台",
          icon1: require("@/CommonDP/assets/settings/myCopysend.svg"),
          icon2: require("@/CommonDP/assets/settings/myCopysend.svg")
        }
      },
      {
        path: "/myApproval",
        name: "myApproval",
        component: () =>
          import("@/CommonDP/pages/components/launchFlow/flowDetail.vue"),
        meta: {
          routeName: "待办详情",
          prouteName: "我的待办",
          pname: "工作台"
        }
      },
      {
        path: "/establishDetail",
        name: "establishDetail",
        component: () =>
          import("@/CommonDP/pages/components/launchFlow/flowDetail.vue"),
        meta: {
          routeName: "创建详情",
          prouteName: "我的创建",
          pname: "工作台"
        }
      },
      {
        path: "/myFinishedDetail",
        name: "myFinished",
        component: () =>
          import("@/CommonDP/pages/components/launchFlow/flowDetail.vue"),
        meta: {
          routeName: "已办详情",
          prouteName: "我的已办",
          pname: "工作台"
        }
      },
      {
        path: "/myCopysendDetail",
        name: "myCopysend",
        component: () =>
          import("@/CommonDP/pages/components/launchFlow/flowDetail.vue"),
        meta: {
          routeName: "抄送详情",
          prouteName: "我的抄送",
          pname: "工作台"
        }
      },
      {
        path: "/myNotice",
        name: "myNotice",
        component: () =>
          import("@/CommonDP/pages/mainMg/workbench/schedule/myNotice.vue"),
        meta: {
          routeName: "我的公告",
          prouteName: "我的公告",
          pname: "工作台",
          icon1: require("@/CommonDP/assets/settings/myNotice.svg"),
          icon2: require("@/CommonDP/assets/settings/myNotice.svg")
        }
      },
      {
        path: '/daily',
        name: 'daily',
        component: () => import('@/CommonDP/pages/mainMg/workbench/daily/daily.vue'),
        meta: {
          routeName: '我的日报',
          prouteName: '我的日报',
          pname: '工作台',
          icon1: require('@/CommonDP/assets/settings/daily.svg'),
          icon2: require('@/CommonDP/assets/settings/daily.svg')
        }
      },
      {
        path: '/weekly',
        name: 'weekly',
        component: () => import('@/CommonDP/pages/mainMg/workbench/weekly/weekly.vue'),
        meta: {
          routeName: '我的周报',
          prouteName: '我的周报',
          pname: '工作台',
          icon1: require('@/CommonDP/assets/settings/weekly.svg'),
          icon2: require('@/CommonDP/assets/settings/weekly.svg')
        }
      }
    ]
  }
];
